import React from "react";
import {useState, useRef, useEffect, useContext} from 'react'
import StockistReportTable from "./StockistReportTable";
import "./StockistReportMain.css";
import { ReactSession } from "react-client-session";
import { getSuccessToast, getErrorToast } from "../../toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import EntriesDataContext from "../../context/EntriesDataContext";



const StockistReportMain = () => {
  const axiosPrivate = useAxiosPrivate();
  const [minDate, setMinDate] = useState(new Date('2000', 0, 1));
  const [maxDate, setMaxDate] = useState(new Date(new Date().setDate(new Date().getDate() + 1)));
  const mindate = useRef();
  const maxdate = useRef();
  const clearRef = useRef();
  const { setResData, setRedirectId } = useContext(EntriesDataContext);
  const [userList, setUserList] = useState([]);
  const [summary, setSummary] = useState({});
  const [completeBox, setCompleteBox] = useState([]);
  const [inCompleteBox, setInCompleteBox] = useState([]);
  const [totalBox, setTotalBox] = useState([]);
  const [tableData, setTableData] = useState([]);
  const role = ReactSession.get("role");
  const [filter, setFilter] = useState({
    startDate: getFirstDayOfMonth(),
    endDate: maxfromat(),
    operator: role === "2" ? "all" : ReactSession.get("username"),
  });

  const [searchCondition, setSearchCondition] = useState({
    startDate: null,
    endDate: null,
    operator: role === "2" ? "all" : ReactSession.get("username"),
  });
  

  useEffect(() => {
    axiosPrivate
      .get(`/dashboard/user-list/${ReactSession.get("username")}`)
      .then((res) => {
        setUserList(res.data["username"]);
      })
      .catch((err) => {
        console.log(err);
        getErrorToast("No Internet connection Found");
      });
  }, [])
  

  const handleFilter = (e) => {
    setFilter({ ...filter, [e.target.name]: e.target.value });
    setSearchCondition({ ...searchCondition, [e.target.name]: e.target.value });
  };

  const filterClick = () => {
    setSearchCondition(filter)
    clearRef.current.value = '';
    if (
      filter["endDate"] !== null &&
      filter["operator"] !== ""
    ) {
      const formDate = new FormData();
      formDate.append(
        "start_date",
        filter["startDate"].toLocaleString({ timeZone: "Asia/Kolkata" })
      );
      formDate.append(
        "end_date",
        filter["endDate"].toLocaleString({ timeZone: "Asia/Kolkata" })
      );
      formDate.append(
        "operator",
        role === "2" ? filter["operator"].toLocaleString({ timeZone: "Asia/Kolkata" })
        : ReactSession.get("username")
      );
      axiosPrivate
        .post("/dashboard/filterby_datename/", formDate)
        .then((response) => {
          if (typeof response.data.data === "object") {
            setSummary(response.data.data);
            setCompleteBox(response.data.data['complete_box_data'])
            setInCompleteBox(response.data.data['incomplete_box_data']);
            setTableData(response.data.data['total_box_data'])
            setResData(response.data.data['total_box_data'])
          } else {
            setSummary({
              total_box: "N/A",
              compile_box: "N/A",
              incompile_box: "N/A",
              total_medicine: "N/A",
            });
            getSuccessToast("No Information found");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      getErrorToast("Select all Fields");
    }
  };
  function maxfromat() {
    let date = new Date();
    let year = date.getFullYear();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    if (month.toString().length === 1) {
      month = `0${month}`;
    }
    if (day.toString().length === 1) {
      day = `0${day}`;
    }
    return `${year}-${month}-${day}`;
  }
  function getFirstDayOfMonth() {
    const d = new Date()
    let year = d.getFullYear() 
    let month = d.getMonth() + 1
    if (month.toString().length === 1) {
      month = `0${month}`;
    }
    return `${year}-${month}-01`;
  }

  return (
    <div className="stockistreportmain-container">
      <p className="stockistreportmain-header">Stockist Information</p>
      <section className="task-container-header" style={{paddingLeft:'2rem', maxWidth:'80%'}}>
        <input
          className="task-container-s-6-date-1 task-container-s-6-input"
          type="date"
          name="startDate"
          id=""
          value={filter['startDate']}
          max={filter["endDate"] === null ? maxfromat() : filter["endDate"]}
          onChange={handleFilter}
        />
        <input
          className="task-container-s-6-date-2 task-container-s-6-input "
          type="date"
          name="endDate"
          id=""
          value={filter["endDate"]}
          min={filter["startDate"]}
          max={maxfromat()}
          onChange={handleFilter}
        />
          {role === "2" ?
        <select
          name="operator"
          className="task-container-s-6-search task-container-s-6-input"
          onChange={handleFilter}
        >
          <option value="all">All Operator</option>
          {userList.map((user) => {
            return (
              <option key={user} value={user}>
              {user}
              </option>
              );
            })}
        </select>
          :null}
        <section className="task-container-s-6-button-section">
          <button className="task-container-s-6-button" 
          onClick={filterClick}
          >
            Filter
          </button>
        </section>
      </section>

      <StockistReportTable
      minDate={minDate}
      maxDate={maxDate}
      tableData={tableData}
      setTableData={setTableData}
      clearRef = {clearRef} 
      searchCondition={searchCondition} />
    </div>
  );
};

export default StockistReportMain;
